<highcharts-chart
  [Highcharts]="highcharts"
  [options]="solidGaugeChartOptions"
  style="width: 100%; height: 48%; display: block"
>
</highcharts-chart>
